/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string, number, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import { statusTagColor } from "util/creditBills";
import { resizableRoute } from "pages/_components/Resizable";

const FieldsDetailCreditBills = (props) => {
    const {
        estado = props.estado,
        fechaVencimiento = props.fechaVencimiento,
        nroComprobante = props.nroComprobante,
        currency = props.currency,
        saldo = props.saldo,
        puntoVenta = props.puntoVenta,
        tipoComprobante = props.tipoComprobante,
        fechaEmision = props.fechaEmision,
        emisorCuit = props.emisorCuit,
        deudorCuit = props.deudorCuit,
        tenedorCuit = props.tenedorCuit,
        emisor = props.emisor,
        deudor = props.deudor,
        tenedor = props.tenedor,
        creditoCbu = props.creditoCbu,
        debitoCbu = props.debitoCbu,
        isDesktop = props.isDesktop,
    } = props;

    return (
        <GridTable className="balance-info fce-emitida">
            <GridTable.Body>
                <GridTable.Container columns={isDesktop ? 3 : 1} rows={16}>
                    <GridTable.Data columnStart={1} rowStart={1}>
                        <CustomData titleText="credit.bills.status" titleTextType="I18N" valueText={estado} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} rowStart={2}>
                        <CustomData
                            titleText="credit.bills.amount"
                            titleTextType="I18N"
                            valueText={<FormattedAmount quantity={saldo} currency={currency} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} rowStart={3}>
                        <CustomData
                            titleText="credit.bills.emision.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={fechaEmision} dateFormat="DD/MM/YYYY" />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 4}>
                        <CustomData
                            titleText="credit.bills.due.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={fechaVencimiento} dateFormat="DD/MM/YYYY" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 6}>
                        <CustomData
                            titleText="credit.bills.selling.point"
                            titleTextType="I18N"
                            valueText={puntoVenta}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 5}>
                        <CustomData
                            titleText="credit.bills.voucher.type"
                            titleTextType="I18N"
                            valueText={tipoComprobante}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 7}>
                        <CustomData
                            titleText="credit.bills.voucher.number"
                            titleTextType="I18N"
                            valueText={nroComprobante}
                        />
                    </GridTable.Data>

                    {/* aqui va un divisor ------------------------------------------------------------------- */}

                    <GridTable.Data
                        columnStart={isDesktop ? 1 : 1}
                        rowStart={isDesktop ? 4 : 8}
                        columnWidth={3}
                        className="horizontal-divider"
                    />

                    <GridTable.Data columnStart={isDesktop ? 1 : 1} rowStart={isDesktop ? 5 : 9}>
                        <CustomData titleText="credit.bills.cuit.emitter" titleTextType="I18N" valueText={emisorCuit} />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 1 : 1} rowStart={isDesktop ? 6 : 10}>
                        <CustomData titleText="credit.bills.emitter" titleTextType="I18N" valueText={emisor} />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 1 : 1} rowStart={isDesktop ? 7 : 15}>
                        <CustomData titleText="credit.bills.credit.cbu" titleTextType="I18N" valueText={creditoCbu} />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 5 : 11}>
                        <CustomData titleText="credit.bills.cuit.debtor" titleTextType="I18N" valueText={deudorCuit} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 6 : 12}>
                        <CustomData titleText="credit.bills.debtor" titleTextType="I18N" valueText={deudor} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 7 : 16}>
                        <CustomData titleText="credit.bills.debit.cbu" titleTextType="I18N" valueText={debitoCbu} />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 5 : 13}>
                        <CustomData titleText="credit.bills.cuit.holder" titleTextType="I18N" valueText={tenedorCuit} />
                    </GridTable.Data>
                    <GridTable.Data ccolumnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 6 : 14}>
                        <CustomData titleText="credit.bills.holder" titleTextType="I18N" valueText={tenedor} />
                    </GridTable.Data>
                </GridTable.Container>
                {!isDesktop && (
                    <GridTable.Data
                        columnStart={2}
                        rowStart={1}
                        rowWidth={1}
                        alignX="flex-end"
                        flexDirection="column"
                        className="credit-bills__tag-status">
                        <InfoTag type="info" message={estado} tagBackground={statusTagColor(estado)} />
                    </GridTable.Data>
                )}
            </GridTable.Body>
        </GridTable>
    );
};

FieldsDetailCreditBills.propTypes = {
    estado: string,
    fechaEmision: string,
    fechaVencimiento: string,
    puntoVenta: string,
    nroComprobante: string,
    tipoComprobante: string,
    emisorCuit: string,
    emisor: string,
    creditoCbu: string,
    deudorCuit: string,
    deudor: string,
    debitoCbu: string,
    tenedorCuit: string,
    tenedor: string,
    currency: string,
    saldo: number,
    isDesktop: bool.isRequired,
};

FieldsDetailCreditBills.defaultProps = {
    estado: "",
    fechaEmision: "",
    fechaVencimiento: "",
    puntoVenta: "",
    nroComprobante: "",
    tipoComprobante: "",
    emisorCuit: "",
    emisor: "",
    creditoCbu: "",
    deudorCuit: "",
    deudor: "",
    debitoCbu: "",
    tenedorCuit: "",
    tenedor: "",
    currency: "",
    saldo: null,
};

export default resizableRoute(FieldsDetailCreditBills);
